var l = /* @__PURE__ */ ((r) => (r.NORMAL = "normal", r.SMALL = "small", r))(l || {});
export {
  l as RocheUISearchInputSize
};
